import styled from 'styled-components'

import device from 'utils/device'
import Logo from 'components/Logo'

export default function Header() {
    return (
        <Container>
            <Logo />
        </Container>
    )
}

const Container = styled.div`
    width: var(--full);
    margin: 0 auto;
    position: relative;
    z-index: 5;
    padding-top: 0.48rem;
    padding-bottom: 0.48rem;
    ${device.mobile} {
        width: auto;
    }
`
